export default {
    BRANCA: 1,
    NEGRA: 2,
    PARDA: 3,
    AMARELA: 4,
    INDIGENA: 5,
}